module.exports = __webpack_public_path__ + "img/check-circle.17928d76.svg";